import { api } from './api';

const getFormats = async () => {
  try {
    const { data } = await api.get(`/v2/dco/formats`);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

export default { getFormats };
